import React from 'react';
import { Link, LinkProps } from 'react-location';

// This component can be used when MUI gives errors about the react-location `Link` component.

/*Ie. `Warning: Function components cannot be given refs. Attempts to access this
    ref will fail. Did you mean to use React.forwardRef()? */

const RouterLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <Link _ref={ref} {...props}>
    {props.children}
  </Link>
));

export default RouterLink;
